module.exports = __webpack_public_path__ + "static/apple-icon-180x180.c581a40b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicon/apple-icon-180x180.png
// module id = 548
// module chunks = 168707334958949